module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#close",
      toString: function () {
        return this.url;
      }
    }